import {useState , useEffect} from "react"
import FormData from "form-data";
import * as ReactBootStrap from "react-bootstrap";
import axios from "axios";

function RcBook() {
  const [cardData, setCardData] = useState(
    {
        Document_Type: "",
        status: "",
        "document_side": "",
        "registration_number": "",
        "owner_name": "",
        "fathers_name": "",
        registration_date: "",
        manufacturing_date: "",
        "manufacturer": "",
        "class": "",
        "chassis_number": "",
        "engine_number": "",
        "fuel": "",
        "body_type": " ",
        "colour": " ",
        cubic_capacity: "",
        "model": "",
        wheel_base: "",
        "state": "",
        "rto_district": "",
        "address": ""
    }
  );
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
        Document_Type: "",
        status: "",
        "document_side": "",
        "registration_number": "",
        "owner_name": "",
        "fathers_name": "",
        registration_date: "",
        manufacturing_date: "",
        "manufacturer": "",
        "class": "",
        "chassis_number": "",
        "engine_number": "",
        "fuel": "",
        "body_type": " ",
        "colour": " ",
        cubic_capacity: "",
        "model": "",
        wheel_base: "",
        "state": "",
        "rto_district": "",
        "address": ""
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://279ldtda8h.execute-api.ap-south-1.amazonaws.com/default/RC_Book_ocrservice-API",
      headers: {
        "x-api-key": "WQL2hNjuz661C81COCiIR8DsPI0j89xKhu3zqNpb",
        authorizationToken: "jG7Xeax73GSSXU1v",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)

      })
      .catch(function (error) {
        setLoading(true)

        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div class="container containerBoreder " id="pan">
        <h2 class="pageTitle">RC BOOK</h2>
        <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />
        <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document_Type</th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th>status</th>
              <td>{cardData.status}</td>
            </tr>
            <tr>
              <th>Document_side</th>
              <td>{cardData.document_side}</td>
            </tr>
            <tr>
              <th>registration_number</th>
              <td>{cardData.registration_number}</td>
            </tr>
            <tr>
              <th>owner_name</th>
              <td>{cardData.owner_name}</td>
            </tr>
            <tr>
              <th>fathers_name</th>
              <td>{cardData.fathers_name}</td>
            </tr> <tr>
              <th>registration_date</th>
              <td>{cardData.registration_date}</td>
            </tr> <tr>
              <th>Manufacturing Date</th>
              <td>{cardData.manufacturing_date}</td>
            </tr> <tr>
              <th>Manufacturer</th>
              <td>{cardData.manufacturer}</td>
            </tr> <tr>
              <th>Class</th>
              <td>{cardData.class}</td>
            </tr> <tr>
              <th>Chassis Number</th>
              <td>{cardData.chassis_number}</td>
            </tr> <tr>
              <th>Engine Number</th>
              <td>{cardData.engine_number}</td>
            </tr> <tr>
              <th>fuel</th>
              <td>{cardData.fuel}</td>
            </tr> <tr>
              <th>Body Type</th>
              <td>{cardData.body_type}</td>
            </tr> <tr>
              <th>Colour</th>
              <td>{cardData.colour}</td>
            </tr> <tr>
              <th>Cubic Capacity</th>
              <td>{cardData.cubic_capacity}</td>
            </tr> <tr>
              <th>Model</th>
              <td>{cardData.model}</td>
            </tr> <tr>
              <th>Wheel Base</th>
              <td>{cardData.wheel_base}</td>
            </tr> <tr>
              <th>State</th>
              <td>{cardData.state}</td>
            </tr> <tr>
              <th>Rto District</th>
              <td>{cardData.rto_district}</td>
            </tr>
            <tr>
              <th>Address</th>
              <td>{cardData.address}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RcBook;
